module.exports = __webpack_public_path__ + "img/ico-ventajas-w.af7816be.svg";